namespace GeniuzPOS.InitialData {
    export class PsDiscCouponTypeSerialColumns {
        static columnsKey = 'InitialData.PsDiscCouponTypeSerial';
    }
}
